import { makeStyles, tokens } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    minHeight: 0,
    overflow: "auto",
  },
  filterDropdown: {
    minWidth: "140px",
  },
  filterListbox: {
    "& [role='option']": {
      flexDirection: "row-reverse",
      justifyContent: "space-between",
    },
  },
  labelCell: {
    cursor: "pointer",
    minWidth: "60px",
    display: "inline-block",
  },
  labelCellPlaceholder: {
    cursor: "pointer",
    minWidth: "60px",
    display: "inline-block",
    color: tokens.colorNeutralForeground4,
  },
  progressCell: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: "100px",
    maxWidth: "180px",
    width: "100%",
  },
  progressBarRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  progressBar: {
    flexGrow: 1,
    minWidth: 0,
  },
  progressFraction: {
    color: designTokens.neutral[500],
    whiteSpace: "nowrap",
  },
  pctBrand: {
    color: designTokens.accent[500],
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  pctWarning: {
    color: designTokens.semantic.warning,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  pctError: {
    color: tokens.colorPaletteRedForeground1,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  hintText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: designTokens.spacing[1],
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    fontFamily: designTokens.fontFamily,
    fontStyle: "italic",
    paddingLeft: "0",
    paddingTop: designTokens.spacing[2],
  },
  selectionCount: {
    fontStyle: "normal",
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.accent[700],
    flexShrink: 0,
  },
});
